export const DEFAULT_PAGE_SIZE = 10 ;

export const formatDate = (date: Date): string => date.toISOString().split("T")[0];

const today = new Date();
export const todayFormatted = formatDate(today);

const twoDaysAgo = new Date();
twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
export const twoDaysAgoFormatted = formatDate(twoDaysAgo);

const sixMonthsAgo = new Date();
sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
sixMonthsAgo.setDate(1); // Set to the 1st of the month
export const sixMonthsAgoFormatted = formatDate(sixMonthsAgo);


// Previous month/year logic
const emiMonth = today.getMonth() === 0 ? 11 : today.getMonth() - 1;
const emiYear = today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear();

// Use UTC to avoid timezone shifting issues
const lastDayOfLastMonth = new Date(Date.UTC(emiYear, emiMonth + 1, 0));

// Final EMI report date
export const emiReportDate = formatDate(lastDayOfLastMonth);



// for WasIS
// Start of previous month
const previousMonthStart = new Date();
previousMonthStart.setMonth(previousMonthStart.getMonth() - 1);
previousMonthStart.setDate(1);

// End of previous month
const previousMonthEnd = new Date();
previousMonthEnd.setDate(0); // Sets to last day of previous month

export const previousMonthStartFormatted = formatDate(previousMonthStart); 
export const previousMonthEndFormatted = formatDate(previousMonthEnd);     
